import Glide from '@glidejs/glide';

// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
    return new Promise(function (resolve, reject) {
        if (document.readyState === 'complete') {
            resolve(document);
        } else {
            document.addEventListener('DOMContentLoaded', function () {
                resolve(document);
            });
        }
    });
};



document.ready().then(function () {

    const testimonialGliders = document.querySelectorAll('.section--testimonials .glide');

    if (testimonialGliders && testimonialGliders.length > 0) {

        const glide = new Glide('.section--testimonials .glide', {
            type: 'carousel',
            autoplay: 10000,
            animationTimingFunc: 'ease-in',
            animationDuration: 600,
            hoverpause: false,
        });

        glide.mount();

    }


    const imageGliders = document.querySelectorAll('.section--imageSlider .glide');
    if (imageGliders && imageGliders.length > 0) {

        const glide = new Glide('.section--imageSlider .glide', {
            type: 'carousel',
            perView: 6,
            autoplay: 5000,
            animationTimingFunc: 'ease-in',
            animationDuration: 600,
            hoverpause: false,
            breakpoints: {
                1440: { perView: 5 },
                1200: { perView: 4 },
                900: {perView: 3},
                550: {
                    perView: 1,
                    
                }
            }
        });

        glide.mount();

    }

    const imageGliders2 = document.querySelectorAll('.section--imageSlider-2 .glide');
    if (imageGliders2 && imageGliders2.length > 0) {

        const glide = new Glide('.section--imageSlider-2 .glide', {
            type: 'carousel',
            perView: 6,
            autoplay: 5000,
            animationTimingFunc: 'ease-in',
            animationDuration: 600,
            hoverpause: false,
            breakpoints: {
                1440: { perView: 5 },
                1200: { perView: 4 },
                900: {perView: 3},
                550: {
                    perView: 1,
                    
                }
            }
        });

        glide.mount();

    }


    const imageQuoteGliders = document.querySelectorAll('.section--imageQuoteSlider .glide');
    if (imageQuoteGliders && imageQuoteGliders.length > 0) {
        const glide = new Glide('.section--imageQuoteSlider .glide', {
            type: 'carousel',
            autoplay: 10000,
            animationTimingFunc: 'ease-in',
            animationDuration: 600,
            hoverpause: false,
        });

        glide.mount();
    }
});